function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1",
  className: "st0"
}, React.createElement("rect", {
  x: 8,
  y: 13,
  className: "st1",
  width: 139,
  height: 126
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2"
}, React.createElement("path", {
  d: "M126,121.5H24c-6.9,0-12.5-5.6-12.5-12.5V44c0-6.9,5.6-12.5,12.5-12.5h102c6.9,0,12.5,5.6,12.5,12.5v65 C138.5,115.9,132.9,121.5,126,121.5z M24,41.5c-1.4,0-2.5,1.1-2.5,2.5v65c0,1.4,1.1,2.5,2.5,2.5h102c1.4,0,2.5-1.1,2.5-2.5V44 c0-1.4-1.1-2.5-2.5-2.5H24z"
}), React.createElement("path", {
  d: "M75.5,91.5c-1.2,0-2.3-0.4-3.3-1.2L18.1,43.5c-2.1-1.8-2.3-5-0.5-7.1c1.8-2.1,5-2.3,7.1-0.5l50.8,44l49.9-43.9 c2.1-1.8,5.2-1.6,7.1,0.4c1.8,2.1,1.6,5.2-0.4,7.1L78.8,90.3C77.9,91.1,76.7,91.5,75.5,91.5z"
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.979898f3.svg";
export { ForwardRef as ReactComponent };